import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalComponent } from 'src/app/private/shared/components/modals/modal/modal.component';
import { ProformViewStates } from 'src/app/private/shared/dtos/proforms.dto';
import { ProformsSubmissionService } from 'src/app/private/shared/services/proforms/proforms-submission.service';
import {
  ProFormContext,
  ProFormsSubmissionAPIResponse,
  ProFormType,
} from 'src/app/private/shared/types/responses/proforms.responses';

@Component({
  selector: 'app-form-page',
  standalone: false,

  templateUrl: './form-page.component.html',
  styleUrl: './form-page.component.scss',
})
export class FormPageComponent implements OnInit {
  @ViewChild('gradedQuizModal')
  gradedQuizModal: ModalComponent;

  isLoading = false;

  formId = 0;

  viewStates = ProformViewStates;

  submission: ProFormsSubmissionAPIResponse | null = null;

  contextType = ProFormContext.SELF;

  gradedFormId: number | null = null;

  gradedSubmissionId: number | null = null;

  isCoachingOnlyForm = false;

  constructor(
    private route: ActivatedRoute,
    private proformsSubmissionService: ProformsSubmissionService
  ) {}

  onFormSubmit(submission: ProFormsSubmissionAPIResponse) {
    this.submission = submission;
  }

  openGradedQuizModal(event: { formId: number; submissionId: number }) {
    this.gradedFormId = event.formId;
    this.gradedSubmissionId = event.submissionId;
    this.gradedQuizModal.open();
  }

  ngOnInit(): void {
    document.body.classList.add('proform');

    this.route.params.subscribe((url) => {
      this.formId = url['formId'];
      this.proformsSubmissionService.getProForm(this.formId).subscribe({
        next: (response) => {
          if (response?.item) {
            const formType = response.item.type as ProFormType;
            this.isCoachingOnlyForm =
              formType === ProFormType.OBSERVATION ||
              formType === ProFormType.CALIBRATION;
          }
        },
      });
    });
  }
}
